import axios from 'axios';
import * as config from "../config";

export const DASHBOARD_SUMMARY_REQUEST= "DASHBOARD_SUMMARY_REQUEST";
export const DASHBOARD_SUMMARY_SUCCESS= "DASHBOARD_SUMMARY_SUCCESS";
export const DASHBOARD_SUMMARY_ERROR= "DASHBOARD_SUMMARY_ERROR";

export function GetSummary(){
    return(dispatch)=>{
        dispatch({
            type:DASHBOARD_SUMMARY_REQUEST
        });

        axios.get(
            config.apiUrl + "/dashboard/summary",
            {
                params:{
                    
                }
            }
        ).then((response)=>{
            dispatch({
                type:DASHBOARD_SUMMARY_SUCCESS,
                payload:response.data.content
            })
        }).catch((error)=>{
            dispatch({
                type:DASHBOARD_SUMMARY_ERROR
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/dashboardSummaryActions.js